module.exports = __webpack_public_path__ + "static/media/collaborate.1896e60f.png";